import { Subject } from 'rxjs';

/**
 * Subject to feed the `[typeahead]` input of ng-select.
 *
 * ng-select >= 15 checks `typeahead.observed` to know whether it must search on the backend, and that
 * property only exists from rxjs 7.2. On rxjs 6 it is undefined, so ng-select silently falls back to
 * filtering the loaded items locally and never emits the typed term.
 */
export class TypeaheadSubject<T = string> extends Subject<T> {
  get observed(): boolean {
    return this.observers.length > 0;
  }
}
